<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <ProductListTableComponent :subscriptions="subscriptions" />

                </div>
            </div>
        
    </div>
    </div>
    
</template>

<script>
    import axios from 'axios';
    import ProductListTableComponent from '../components/ProductListTable.vue';
    export default {
        components: { ProductListTableComponent },
        data() {
            return {
                subscriptions: [],
                loading: true,
                error: null,
                pollingInterval: null
            };
        },
        created() {
            this.fetchSubscriptionData();
        },
        mounted() {
            // Start polling every 10 seconds
            this.pollingInterval = setInterval(() => {
                this.fetchSubscriptionData();
            }, 10000);
        },
        beforeUnmount() {
            // Clear polling when component is destroyed
            clearInterval(this.pollingInterval);
        },
        methods: {
            fetchSubscriptionData() {
                const customerId = localStorage.getItem('customerId');
                if(customerId != undefined){
                    axios.get('/api/zoho/customer-subscriptions/' + customerId)
                    .then(response => {
                        let data = response.data;
                        this.subscriptions = data.subscriptions;
                    })
                    .catch(() => {
                        this.error = 'Failed to fetch services.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
            }

        },
    };
</script>

<style scoped>
/* Add dashboard styles here */
</style>
